import { HStack, Text } from '@chakra-ui/react';
import React from 'react';

import { finleyAssertUnreachable } from '@finley-technologies/common';
import { Bank } from '@finley-technologies/finley-types';

import { colors } from '~/packages/common-frontend/colors';
import { Icon } from '~/packages/common-frontend/components/icons';
import { formatCurrencyAmount } from '~/packages/common-frontend/utils';

// @jendevelops need to tie this type to funding request types from funding.request
type ConstraintType = 'minimum' | 'maximum' | 'increment';

type CheckConstraintProps = {
  type: ConstraintType;
  value: number;
  constraintValue: number;
};

const createMaxConstraint = (max: number) => ({
  // @jendevelops TODO update for other currencies
  label: `Maximum: ${formatCurrencyAmount(max, Bank.Currency.USD)}`,
  isPassingConstraint: (value: number) => value <= max,
});

const createMinConstraint = (min: number) => ({
  // @jendevelops TODO update for other currencies
  label: `Minimum: ${formatCurrencyAmount(min, Bank.Currency.USD)}`,
  isPassingConstraint: (value: number) => value === 0 || value >= min,
});

const createIncrementConstraint = (increment: number) => ({
  // @jendevelops TODO update for other currencies
  label: `Increment: ${formatCurrencyAmount(increment, Bank.Currency.USD)}`,
  isPassingConstraint: (value: number) => value % increment === 0,
});

const getConstraintPayload = (type: ConstraintType) => {
  switch (type) {
    case 'minimum':
      return createMinConstraint;
    case 'maximum':
      return createMaxConstraint;
    case 'increment':
      return createIncrementConstraint;
    default:
      return finleyAssertUnreachable(type);
  }
};

export const CheckConstraint = ({
  type,
  value,
  constraintValue,
}: CheckConstraintProps) => {
  const { label, isPassingConstraint } = getConstraintPayload(type)(
    constraintValue,
  );
  return (
    <HStack spacing="8px">
      {isPassingConstraint(value) ? (
        <Icon icon="circle-check" color={colors.green[400]} />
      ) : (
        <Icon icon="circle-x" color={colors.red[400]} />
      )}
      <Text fontSize="sm" color={colors.gray[400]}>
        {label}
      </Text>
    </HStack>
  );
};
